import React from 'react';
import FormInput from '../form-input/form-input.component';
import CustomButton from '../custom-button/custom-buttom.component';
import {auth} from '../../firebase/firebase.utils';
import './sign-in.style.scss';
import SignUp from '../sign-up/sign-up.component';
import { Link } from 'react-router-dom';



class SignIn extends React.Component{
    constructor(props){
        super(props);
        this.state={
            email:'',
            password:'',
            clicked: false,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({
          clicked: true
     
        });
      }

        handleSubmit = async event =>{
            event.preventDefault();

            const {email,password}= this.state;

            try{
                await auth.signInWithEmailAndPassword(email,password);
                this.setState({email:'', password:''});
            }
            catch(error){
                console.log(error);

            }
        };


        handleChange = event =>{
            const {value,name} = event.target;
            this.setState({ [name]:value });
        };

    
    render(){
        return(
            
        <div className='sign-in-container'> 
            <div className='sign-in'>
             
                 <form onSubmit={this.handleSubmit} >
                    
                    <FormInput 
                    name="email" 
                    type="email" 
                    value={this.state.email} 
                    onChange={this.handleChange} 
                    label='Емаил' 
                    required />
                    
                    <FormInput 
                    name="password" 
                    type="password" 
                    value={this.state.password} 
                    onChange={this.handleChange} 
                    label='Лозинка' 
                    required />
                        
                    <div className='buttons' > 
                     <CustomButton type="submit" > ПРИЈАВИ СЕ </CustomButton>
                    
                     <Link className='register-button' to='/registracija'>УПУТСТВО ЗА РЕГИСТРАЦИЈУ</Link> 
                

                    </div>
                </form>
            
             
                <div>

{ this.state.clicked ? ( <SignUp  />):null}
</div>
            </div></div>
        );
    }
}

export default SignIn;